import { defineStore } from '/builds/gitlab/gitlab-ee/node_modules/pinia/dist/pinia.mjs?vue3';
import { useCommitModalState } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/commit/store/composables/use_commit_modal_state.js?vue3';

export const useRevertCommit = defineStore('revertCommit', () => useCommitModalState());
